import type {
    GetCommerceProductCategoriesRequest,
    GetCommerceProductCategoriesResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const getCommerceProductCategoriesOperation = defineCommerceOperation<
    GetCommerceProductCategoriesRequest,
    GetCommerceProductCategoriesResponse
>("commerce.product-categories.list");
